
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.5 24.418V11.97c0-.812.658-1.47 1.47-1.47h0c.812 0 1.47.658 1.47 1.47v9.674c0 .845.685 1.53 1.53 1.53h0a1.53 1.53 0 001.53-1.53V12A1.5 1.5 0 018 10.5h0A1.5 1.5 0 019.5 12v9.674a1.5 1.5 0 001.5 1.5h0a1.5 1.5 0 001.5-1.5V12a1.5 1.5 0 011.5-1.5h0a1.5 1.5 0 011.5 1.5v12.5"}}),_c('path',{attrs:{"d":"M5 1L3.338 2.24A1.018 1.018 0 003.5 3.97h0a1.032 1.032 0 01.175 1.748L2 7m7-6L7.338 2.24A1.018 1.018 0 007.5 3.97h0a1.032 1.032 0 01.175 1.748L6 7m7-6l-1.662 1.24a1.018 1.018 0 00.162 1.73h0a1.032 1.032 0 01.175 1.748L10 7","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    